export class SelectBinding {
    constructor(public first: number, public secondary: number, public type: string) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/domain/selectBinding.ts